// extracted by mini-css-extract-plugin
module.exports = {"landing":"style_landing__3d_t3","link":"style_link__2CtN4"};